'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slick = void 0;
var $ = require("jquery");
require("slick-carousel");
var Slick = /** @class */ (function () {
    function Slick() {
        // スライドが変わった後のイベント
        $('.bulletSlick').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            $('.trigSwitchSlick').attr('data-is-active', 'false');
            $('.trigSwitchSlick').eq(currentSlide).attr('data-is-active', 'true');
        });
        var mySlick = $('.bulletSlick').slick({
            autoplay: true,
            autoplaySpeed: 3000,
            asNavFor: '.bulletSlick'
        });
        $('.trigSwitchSlick').on('click', function (e) {
            var index = $(e.currentTarget).index();
            mySlick.slick('slickGoTo', index, false);
        });
    }
    return Slick;
}());
exports.Slick = Slick;
exports.default = Slick;
